export const STATE_NAME = 'feedback';

export const FETCH_FEEDBACK = 'FETCH_FEEDBACK';
export const FETCH_FEEDBACK_DONE = 'FETCH_FEEDBACK_DONE';
export const FETCH_FEEDBACK_FAIL = 'FETCH_FEEDBACK_FAIL';

export const HIGHLIGHT_FEEDBACK = 'HIGHLIGHT_FEEDBACK';
export const HIGHLIGHT_FEEDBACK_DONE = 'HIGHLIGHT_FEEDBACK_DONE';
export const HIGHLIGHT_FEEDBACK_FAIL = 'HIGHLIGHT_FEEDBACK_FAIL';

export const DELETE_FEEDBACK = 'DELETE_FEEDBACK';
export const DELETE_FEEDBACK_DONE = 'DELETE_FEEDBACK_DONE';
export const DELETE_FEEDBACK_FAIL = 'DELETE_FEEDBACK_FAIL';

export const FETCH_FEEDBACK_COUNT = 'FETCH_FEEDBACK_COUNT';
export const FETCH_FEEDBACK_COUNT_DONE = 'FETCH_FEEDBACK_COUNT_DONE';
export const FETCH_FEEDBACK_COUNT_FAIL = 'FETCH_FEEDBACK_FAIL';
